import React from "react";



export default function ExplanationCard({ explain }) {
    
    return (
      <div >
        
        <h2 className="explanation">{explain}</h2>
      </div>
       
    );
  };